import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../../store/authSlice';



const initialState = {
    nom: '',
    prenom: '',
    username: '',
    role: 'user',
    email: '',
    password: '',
    businessid: '',
}

function AuthRegister() {
    const [formData, setFormData] = useState(initialState);

    const [error, setError] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    function onSubmit(event) {
        event.preventDefault();
        dispatch(registerUser(formData)).then((data) => {
            // vider le formulaire
            setFormData(initialState);
            // rediriger vers la page de connexion
            navigate('/login');
        })
    }

    function handlePasswordConfirm(e) {
        const confirmValue = e.target.value;
        //setFormData({ ...formData, passwordConfirm: confirmValue });

        // vérifier si le mot de passe et la confirmation correspondent
        if (confirmValue !== formData.password) {
            setError("Les mots de passe ne correspondent pas.");
        } else {
            setError("");
        }
    }


    const [isAccepted, setIsAccepted] = useState(false);

    const handleToggle = () => {
        setIsAccepted((prev) => !prev);
    };
    return (
        <>
            {/* strat content */}

            <div className="space-y-8 bg-white px-4 py-6 rounded-md w-full max-w-sm">
                <h1 className="font-semibold text-center text-xl">Inscription</h1>
                <form onSubmit={onSubmit} className="space-y-6">
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="text"
                        name="nom"
                        onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                        placeholder="Votre nom"
                        required
                    />
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="text"
                        name="prenom"
                        onChange={(e) => setFormData({ ...formData, prenom: e.target.value })}
                        placeholder="Votre prenom"
                        required
                    />
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="text"
                        name="username"
                        onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                        placeholder="Nom d'utilisateur"
                        required
                    />
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="email"
                        name="email"
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="Votre Email"
                        required
                    />
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="text"
                        name="businessid"
                        onChange={(e) => setFormData({ ...formData, businessid: e.target.value })}
                        placeholder="ID entreprise"
                        required
                    />
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="password"
                        name="password"
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                        placeholder="Password"
                        required
                    />
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="password"
                        onChange={handlePasswordConfirm}
                        name="passwordConfirm"
                        placeholder="Confirmer le mot de passe"
                        required
                    />
                    {error && <p className="mt-2 text-red-500 text-sm">{error}</p>}
                    <div className="flex justify-between items-center">
                        {/*Remember me toggle */}
                        <label
                            className="flex items-center cursor-pointer"
                            onClick={handleToggle}
                        >
                            <div
                                className={`inline-flex relative items-center w-10 h-5 rounded-full transition-colors duration-300 ${isAccepted ? "bg-teal-500" : "bg-gray-300"
                                    }`}
                            >
                                <span
                                    className={`absolute w-6 h-6 rounded-full shadow-md transform transition-transform duration-500 ${isAccepted ? "translate-x-5 bg-teal-600" : "translate-x-0 bg-gray-400"
                                        }`}
                                ></span>
                            </div>
                            <span className="ml-3 font-normal text-gray-500 text-sm dark:text-gray-400">
                                J'accepte les{" "}
                                <a href="/" className="text-sm text-teal-500 hover:underline">
                                    termes et conditions
                                </a>
                            </span>
                        </label>
                    </div>
                    <div>
                        <button
                            type="submit"
                            disabled={!isAccepted}
                            className="bg-teal-400 disabled:bg-gray-400 px-4 py-2 rounded-md focus:ring-2 focus:ring-primary focus:ring-offset-1 dark:focus:ring-offset-darker w-full font-medium text-center text-white transition-colors duration-200 focus:outline-none"
                        >
                            S'enregistrer
                        </button>
                    </div>
                </form>

                <div className="flex flex-nowrap justify-center items-center space-x-2">
                    <span className="bg-gray-300 w-20 h-px"></span>
                    <span>OU</span>
                    <span className="bg-gray-300 w-20 h-px"></span>
                </div>

                <div className="text-gray-600 text-sm dark:text-gray-400">
                    Vous avez deja un compte ? <a href="login" className="text-teal-600 hover:underline"> se connecter</a>
                </div>
            </div>

            {/* end content */}
        </>
    )
}

export default AuthRegister